import React, {Component} from 'react';
import questionsDataSet from '../../../data/questions';

export default class Questions extends Component {

  constructor(props) {
    super(props);
    this.otherQuestion = React.createRef();
    this.state = {
      question: questionsDataSet[0],
    };
    this.getRandomQuestion = this.getRandomQuestion.bind(this);
  };

  getRandomQuestion = () => {
    let val = Math.floor(Math.random() * Math.floor(3));
    this.setState({question: questionsDataSet[val]});
  };

  render() {
    const styles = {
      container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: 2,
        marginTop: 30,
        fontSize: '1.3em',
      },
      containerQuestion: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
      },
      containerResponse: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
      },
      otherQuestionBtn: {
        marginTop: 30,
        color: 'black'
      },
      label: {
        margin: 10,
      }
    };

    const {question, otherQuestion} = this.state;

    return (
      <div>
        <div style={styles.container}>
          <div style={styles.containerQuestion}>
            <strong>{question.label}</strong>
            &nbsp;<i className="material-icons" onClick={() => this.getRandomQuestion()}>cached</i>
          </div>
          <div style={styles.containerResponse}>
            <label style={styles.label}>
              <input name={`group${question.id}`} type="radio" value='yes' onChange={this.props.onChange}/>
              <span>Oui</span>
            </label>
            <br/>
            <label style={styles.label}>
              <input name={`group${question.id}`} value='no' type="radio" onChange={this.props.onChange}/>
              <span>Non</span>
            </label>
          </div>
          <a style={styles.otherQuestionBtn}><i className="material-icons"
                                                onClick={() => this.setState({otherQuestion: !this.state.otherQuestion})}>add_circle_outline</i></a>
          {otherQuestion &&
          <input ref={this.otherQuestion} placeholder="Préciser votre question" type="text" class="validate"/>}
        </div>
      </div>
    );
  }
}